
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/politicas-de-privacidade",
      function () {
        return require("private-next-pages/politicas-de-privacidade/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/politicas-de-privacidade"])
      });
    }
  